module.exports = __webpack_public_path__ + "img/prof8.4d79e6a6.jpg";